import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { candidateApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for get all location
export const allWorkAuthorization = createAsyncThunk(
  "work/authorization",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get("/candidate/candidate/get-work-authorization/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for add a work authorization
export const addWorkAuthorization = createAsyncThunk(
  "add/work_authorization",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.post("/candidate/candidate/create-update-work-authorization/",userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const workAuthorizationSlice = createSlice({
  name: "workautho",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(allWorkAuthorization.pending, (state) => {
        state.status = "loading";
      })
      .addCase(allWorkAuthorization.fulfilled, (state, action) => {
        state.status = "get_location_succeeded";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(allWorkAuthorization.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(addWorkAuthorization.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addWorkAuthorization.fulfilled, (state, action) => {
        state.status = "add_work_authorization_succeeded";
        // state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(addWorkAuthorization.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
  },
});

export default workAuthorizationSlice.reducer;
